<template>
  <div class="game">
    <a href="#" @click.prevent="play">
      <img :alt="game.name" :src="game.icon">
    </a>
    <a href="#" @click.prevent="toggleFavorite(game)" v-if="store.getters.isLoggedIn && hideFav !== true" class="fav" :class="{selected: game.isFavorite}">
      <svg-icon icon="fav" class="d-flex"/>
    </a>
    <a href="#" @click.prevent="play" class="name">{{ game.name }}</a>
  </div>
</template>

<script setup lang="ts">
import GameDTO from "@/models/GameDTO";
import SvgIcon from "@/components/SvgIcon.vue";
import {useStore} from "vuex";
import {api} from "@/service/APIClient";
import {useRouter} from "vue-router";

const props = defineProps<{
  game: GameDTO,
  hideFav?: boolean|undefined,
  beforePlay?: () => {}|undefined
}>()

const router = useRouter()

const emit = defineEmits(['favoriteChanged'])

const store = useStore()
const toggleFavorite = (game: GameDTO) => {
  api.call.games.toggleFavorite(game.id, game.isFavorite ? 'unmark' : 'mark')
  emit('favoriteChanged', {...game, isFavorite: !game.isFavorite})
}

const play = async () => {
  if (!store.getters.isLoggedIn) {
    router.push({name: 'login'})
    return;
  }

  props.beforePlay && await props.beforePlay()
  router.push({name: 'gameWrapper', params: {id: props.game.id}})
}

</script>